export enum INPUT_TYPE_ENUM {
    PHONE = 'phone',
    DOB = 'dob'
}
